import { GameData, useGetUserCountry } from 'react-easyrocket';
import { PRAGMATIC_LIVE_PROVIDER_ID, PRAGMATIC_PROVIDER_ID } from 'src/constants/gameProvider';

export const useHideBlockedImage = ({ game }: { game: GameData }) => {
  const { imagine, providerId } = game || {};
  const { userCountry } = useGetUserCountry({ enabled: false });
  const isFin = userCountry?.country === 'FIN';
  const isCountryBlock = imagine?.files?.desktop.includes('countryblocked');
  const isPragmaticProvider =
    providerId === PRAGMATIC_PROVIDER_ID || providerId === PRAGMATIC_LIVE_PROVIDER_ID;

  return isFin && isPragmaticProvider && isCountryBlock;
};
